<template>
  <div id="app">
    <img
      src="../assets/img/audit_bg.png"
      class="audit_bg"
      style="width: 100%"
      alt=""
      srcset=""
    />
    <div class="state">
      <van-steps
        class="steps_state"
        direction="vertical"
        active-color="#4997F4"
        :active="active"
      >
        <van-step>
          <template #inactive-icon>
            <van-icon
              v-if="active == 0"
              name="https://xm-evaluate-file.oss-cn-beijing.aliyuncs.com/Image/2021-07/LVI3auU6Sb.png"
            />
            <van-icon v-else color="#4997F4" name="checked" />
          </template>
          <template #active-icon>
            <!-- <van-icon color="#F35728" name="clear" /> -->
            <van-icon color="#4997F4" name="checked" />
          </template>
          <h3 style="position: relative; color: #20293c">
            填写报名信息
            <!-- <van-button
              size="mini"
              class="btn_state"
              v-if="active == 0"
              @click="toIndex"
              round
              type="info"
              >完善孩子信息</van-button
            > -->
            <span
              v-if="active == 0"
              @click="toIndex"
              class="btn_state btn_select"
            >
              完善孩子信息
            </span>
          </h3>
          <p
            class="step_one_color"
            style="display: inline-block; padding-top: 0.4rem"
          >
            您的材料已提交！
          </p>
          <!-- <p class="step_one_color">请携带所需纸质材料于</p>
          <p class="step_one_color">
            {{ info.sceneStartTime }} — {{ info.sceneEndTime }}
          </p>
          <p class="step_one_color" style=" position: relative;">
            现场审核
            
          </p> -->
        </van-step>
        <van-step>
          <template #inactive-icon>
            <van-icon
              v-if="active == 0"
              name="https://xm-evaluate-file.oss-cn-beijing.aliyuncs.com/Image/2021-07/0eydqkvlfr.png"
            />
            <van-icon v-else color="#4997F4" name="checked" />
          </template>
          <template #active-icon>
            <van-icon
              v-if="firstTrialStatus == 1"
              color="#FF6F44"
              name="https://xm-evaluate-file.oss-cn-beijing.aliyuncs.com/Image/2021-07/0eydqkvlfr.png"
            />
            <van-icon
              v-if="firstTrialStatus == 3"
              color="#FF6F44"
              name="clear"
            />
            <van-icon
              v-if="firstTrialStatus == 2"
              color="#4997F4"
              name="checked"
            />
          </template>
          <h3 style="color: #20293c">材料审核</h3>
          <p
            class="step_two_color"
            style="display: inline-block; padding-top: 0.13rem"
            v-if="firstTrialStatus == 3"
          >
            您的材料审核未通过！
          </p>
          <div v-if="firstTrialStatus == 2">
            <p
              class="step_one_color"
              style="display: inline-block; padding-top: 0.13rem"
            >
              恭喜您，材料审核通过！
            </p>
          </div>
        </van-step>
        <van-step>
          <template #inactive-icon>
            <van-icon
              v-if="admissionStatus == 1"
              name="https://xm-evaluate-file.oss-cn-beijing.aliyuncs.com/Image/2021-07/Kr2MphyvXK.png"
            />
            <van-icon
              v-if="admissionStatus == 3 || admissionStatus == 2"
              color="#4997F4"
              name="checked"
            />
          </template>
          <template #active-icon>
            <van-icon
              v-if="admissionStatus == 1"
              name="https://xm-evaluate-file.oss-cn-beijing.aliyuncs.com/Image/2021-07/Kr2MphyvXK.png"
            />
            <van-icon
              v-if="admissionStatus == 4"
              color="#FF6F44"
              name="clear"
            />
            <van-icon
              v-if="admissionStatus == 3 || admissionStatus == 2"
              color="#4997F4"
              name="checked"
            />
          </template>
          <h3 style="color: #20293c">资格审查</h3>
          <div
            class="step_two_color"
            style="padding-top: 0.13rem"
            v-if="firstTrialStatus == 2"
          >
            <p v-if="admissionStatus == 1">资格审查中</p>
            <p v-if="admissionStatus == 4">资格审查未通过</p>
            <p v-if="admissionStatus == 2 || admissionStatus == 3">
              资格审查通过
            </p>
            <p v-if="admissionStatus == 4&&reason!=''" style="    margin-top: 10px;font-size: 12px;color: #666;">
              不通过原因：{{reason}}
            </p>
          </div>
        </van-step>
        <van-step>
          <template #inactive-icon>
            <van-icon
              v-if="admissionStatus == 2 || admissionStatus == 3"
              color="#4997F4"
              name="checked"
            />
            <van-icon
              v-else
              name="https://xm-evaluate-file.oss-cn-beijing.aliyuncs.com/Image/2021-07/IS0epGMXS2.png"
            />
          </template>
          <template #active-icon>
            <!-- <van-icon color="#F35728" name="clear" /> -->
            <van-icon color="#4997F4" name="checked" />
          </template>
          <h3 style="color: #20293c">正式录取</h3>
          <!-- <van-button
            size="small"
            class="btn_state"
            style="margin-top: 15px"
            v-if="active == 3"
            @click="toResults"
            round
            type="info"
            >查看录取通知书</van-button
          > -->
          <div style="text-align: center">
            <span
              style="margin-top: 0.6rem; padding: 0.2rem 0.74rem"
              v-if="showResultsBtn"
              @click="toResults"
              class="btn_select"
            >
              查看录取通知书
            </span>
          </div>
        </van-step>
      </van-steps>
    </div>
  </div>
</template>
<script>
import { getStudentByIdcard, getSchoolConfig } from "@/api/home";
export default {
  data() {
    return {
      idcard: 0,
      schoolId: 0,
      active: 0,
      studentSignVo: {},
      state: 0,
      info: {},
      admissionStatus: 0,
      firstTrialStatus: 0,
      reason: '',
      admissionStartTime: '',
      admissionEndTime: ''
    };
  },
  computed: {
    showResultsBtn() {
      if (this.firstTrialStatus != 2) return false
      if (this.admissionStatus != 2 && this.admissionStatus != 3) return false
      if (!this.admissionStartTime || !this.admissionEndTime) {
        return true
      }
      const now = Date.now()
      const start = new Date(String(this.admissionStartTime).replace(/-/g, '/')).getTime()
      const end = new Date(String(this.admissionEndTime).replace(/-/g, '/')).getTime()
      if (isNaN(start) || isNaN(end)) return true
      return now >= start && now <= end
    }
  },
  created() {
    this.idcard = this.$route.query.idCard;
    this.schoolId = this.$route.query.schoolId;
  },
  mounted() {
    this.loadPageData();
  },
  methods: {
    loadPageData() {
      Promise.all([this.fetchStudentInfo(), this.fetchSchoolConfig()]).then(() => {
        this.updateActiveStep();
      });
    },
    fetchSchoolConfig() {
      return getSchoolConfig({ schoolId: this.schoolId }).then((res) => {
        if (res.data.code != 0 && String(res.data.code) !== '0') return
        const data = res.data.data || {}
        this.admissionStartTime = data.admissionStartTime || ''
        this.admissionEndTime = data.admissionEndTime || ''
      })
    },
    fetchStudentInfo() {
      let params = {
        schoolId: this.schoolId,
        studentIdcard: this.idcard,
      };
      return getStudentByIdcard(params).then((res) => {
        let data = res.data.data.studentSignVo;
        this.studentSignVo = data;
        this.admissionStatus = data.admissionStatus;
        this.reason = data.reason;
        this.firstTrialStatus = data.firstTrialStatus;
        let info = res.data.data.enrollmentSchoolConfigVo;
        if (info.sceneStartTime) {
          info.sceneStartTime = info.sceneStartTime.slice(0, -3);
        }
        if (info.sceneEndTime) {
          info.sceneEndTime = info.sceneEndTime.slice(0, -3);
          info.sceneEndTime = info.sceneEndTime.slice(5);
        }
        this.info = info;
      });
    },
    updateActiveStep() {
      if (this.firstTrialStatus == 1) {
        this.active = 0
        return
      }
      if (this.firstTrialStatus == 3) {
        this.active = 2
        return
      }
      if (this.showResultsBtn) {
        this.active = 3
        return
      }
      if (this.firstTrialStatus == 2) {
        this.active = 2
      }
    },
    toIndex() {
      this.$router.push({
        path: "/index",
        query: {
          schoolId: this.schoolId,
          idCard: this.idcard,
          studentName: this.studentSignVo.studentName,
          state: 1,
          id: this.studentSignVo.id,
        },
      });
    },
    toResults() {
      this.$router.push({
        path: "/results",
        query: {
          schoolId: this.schoolId,
          idCard: this.idcard,
          studentName: this.studentSignVo.studentName,
        },
      });
    },
  },
};
</script>
<style scoped>
#app {
  position: relative;
  height: 100vh;
  width: 100%;
}
.van-step {
  height: 2.67rem;
}
.van-step--vertical:not(:last-child)::after {
  border-bottom-width: 0rem;
}
.state {
  width: 90vw;
  margin: 0 auto;
  padding-top: 23.5vh;
}
.van-step--finish {
  color: #4997f4;
}
.state p {
  font-size: 0.37rem;
}
.btn_state {
  position: absolute;
  top: -0.17rem;
  right: 0;
  color: #fff;
  background-color: #4997f4;
  border: none;
}
.audit_bg {
  position: absolute;
  width: 100%;
  z-index: -1;
}
.steps_state {
  border-radius: 0.4rem;
  padding: 30px 40px;
  box-sizing: border-box;
}
.step_one_color {
  color: #ff6d4e;
}
.step_two_color {
  color: #20293c;
}
.btn_select {
  display: inline-block;
  padding: 0.2rem 0.35rem;
  background-color: #4997f4;
  border-radius: 0.53rem;
  color: #fff;
  font-size: 0.32rem;
}
</style>


// WEBPACK FOOTER //
// src/view/state.vue